import {
  captureFunnelEvent,
  type FunnelCaptureClient,
} from './capture-funnel-event';
import type { ResponseFunnelTarget } from './capture-response.types';
import { createSessionOnceGuard } from './session-once-guard';

const startedGuard = createSessionOnceGuard('response_started_');

export function readResponseStartedAt(responseId: string): number | null {
  const value = startedGuard.read(responseId);
  if (value === null) return null;

  const startedAt = parseInt(value, 10);

  return Number.isFinite(startedAt) ? startedAt : null;
}

export function hasResponseStarted(responseId: string): boolean {
  return startedGuard.has(responseId);
}

export function captureResponseStartedOnce(
  posthog: FunnelCaptureClient | null | undefined,
  { projectId, responseId }: ResponseFunnelTarget
): void {
  if (!projectId || !responseId || startedGuard.has(responseId)) return;

  startedGuard.mark(responseId);

  captureFunnelEvent(posthog, 'response_started', {
    project_id: projectId,
    response_id: responseId,
  });
}
